<section class="login_section">
  <!-- Full Page Intro -->
  <div class="view">
    <!-- Mask & flexbox options-->
    <div class="mask rgb-gradient d-flex justify-content-center align-items-center">
      <!-- Content -->
      <div class="container">
        <!--Grid row-->
        <!--Grid column-->
        <div class="col-lg-5 col-md-8 col-sm-9 ml-auto mr-auto">
          <!--Form-->
          <mdb-card class="wow fadeInRight p-1" data-wow-delay="0.3s">
            <mdb-card-body class="z-depth-2 p-4">
              <form [formGroup]="reistrationForm">
                <div class="login__logo" style="margin:0 auto 2rem auto;">
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/educational_documents/Miles%20Website%20Images/home/MilesEducation_Main_Logo.png" alt="Miles CPA LMS" style="width:300px; margin: auto;">
                  </a>
                </div>
                <!--Header-->
                <div class="text-center">
                  <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase">
                    Register
                  </h3>
                </div>
                <!--Body-->
                <div class="md-form md-outline">
                  <mdb-icon fas icon="user" class="text-black-50"></mdb-icon>
                  <input type="text" id="inputIconEx1" class="form-control" mdbInput mdbValidate formControlName="fname" name="fname">
                  <label for="inputIconEx1">First Name</label>
                </div>
                <div class="md-form md-outline">
                  <mdb-icon fas icon="user" class="text-black-50"></mdb-icon>
                  <input type="text" id="inputIconEx2" class="form-control" mdbInput mdbValidate formControlName="lname" name="lname">
                  <label for="inputIconEx2">Last Name</label>
                </div>
                <div class="md-form md-outline">
                  <mdb-icon fas icon="envelope" class="text-black-50"></mdb-icon>
                  <input type="text" id="inputIconEx3" class="form-control" mdbInput mdbValidate formControlName="email" name="email">
                  <label for="inputIconEx3">Email</label>
                </div>
                <div class="md-form md-outline">
                  <mdb-icon fas icon="lock" class="text-black-50"></mdb-icon>
                  <input type="password" id="inputIconEx4" class="form-control" mdbInput mdbValidate formControlName="password" name="password">
                  <label for="inputIconEx4">Password</label>
                </div>
                <div class="md-form md-outline">
                  <mdb-icon fas icon="mobile" class="text-black-50"></mdb-icon>
                  <input type="text" id="inputIconEx5" class="form-control" mdbInput mdbValidate formControlName="phone" name="phone">
                  <label for="inputIconEx5">Contact Number</label>
                </div>
                <hr>
                <div class="d-flex justify-content-around flex-lg-row flex-md-row flex-sm-row flex-column">
                  <div>
                    <!-- Remember me -->
                    <mdb-checkbox [default]="true" class="text-black-50 f-15">I accept terms and conditions.
                    </mdb-checkbox>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button mdbBtn gradient="blue" mdbWavesEffect routerLink="/successfully-register" (click)="register()">Register</button>
                </div>
                <p class="register_txt mt-3">Already have an account?<a routerLink=""
                    class="text-black-50 f-15 text-center">Login</a></p>
              </form>
            </mdb-card-body>
          </mdb-card>
          <!--/.Form-->
        </div>
        <!--Grid row-->
      </div>
      <!-- Content -->
    </div>
    <!-- Mask & flexbox options-->
  </div>
  <!-- Full Page Intro -->
</section>

<!--<div class="container my-5">
    <div class="p-5 pl-0">
      <a href="#" routerLink="forgot-password">Forgot</a>
    </div>
  </div>-->
